// Tracks daily feature usage in localStorage. Resets automatically each day.

const today = () => new Date().toISOString().split("T")[0]; // YYYY-MM-DD

export function getUsageCount(featureKey) {
  try {
    const stored = localStorage.getItem(`flybnb_usage_${featureKey}`);
    if (!stored) return 0;
    const { date, count } = JSON.parse(stored);
    if (date !== today()) return 0;
    return count;
  } catch {
    return 0;
  }
}

export function incrementUsage(featureKey) {
  try {
    const count = getUsageCount(featureKey) + 1;
    localStorage.setItem(
      `flybnb_usage_${featureKey}`,
      JSON.stringify({ date: today(), count })
    );
    return count;
  } catch {
    return 1;
  }
}

export function canUseFeature(featureKey, limit, isPro) {
  if (isPro) return true;
  if (window.location.hostname === "localhost") return true;
  return getUsageCount(featureKey) < limit;
}
